module.exports = __webpack_public_path__ + "img/cecil_dancing.6dd6532a.jpg";